import LMSDispatcher from "../LMSDispatcher";

import { IApi, Api } from '../../utilities/Api';
import { ApiRequest } from '../../utilities/ApiRequest';
import * as ACTIONCONTANTS from './ActionConstants';
import SourceViewData, { ISourceViewData} from "../../models/source/SourceViewData";
import ISourceFormData from "../../models/source/SourceFormData";
import i18next from "i18next";

class SourceActions {
    private readonly api: IApi;

    constructor() {
        this.api = new Api(ACTIONCONTANTS.SAMPLE_ENDPOINT);
    }

    async getById(id: string) {
        try {
            const request = new ApiRequest("/source/" + id, "", null, i18next.t("Source not found"));
            const result = await this.api.get(request);
            const payload = this.convertResponseData(result.data);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SOURCE_GET_BY_ID,
                payload: {
                    sourceData: payload,
                }
            });
        } catch (error) {
            throw error;
        }
    }

    async getAll(page: number, pageSize: number, sort: string, order: string, filter: string) {
        try {
            const request = new ApiRequest(`/source/${page}/${pageSize}/${sort}/${order}/${filter}`, "", null, i18next.t("Unable to fetch source."));
            const result = await this.api.get(request);
            const payload = this.convertResponseListData(result.data);            
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SOURCE_GET_ALL,
                payload: {
                    sourceDataList: payload,
                }
            });
        } catch (error) {
            throw error;
        }
    }

    async post(data: ISourceFormData): Promise<void> {
        try {
            const payload: any = this.preparePostPayload(data);

            const request = new ApiRequest("/source", data.requestId, payload, i18next.t("Source created."));
            const result = await this.api.post(request);
            
            
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SOURCE_SUBMIT,
                payload: {
                    Id: result.data,
                    message: result.message
                }
            });
        } catch (error) {
            throw error
        }
    }

    async put(data: ISourceFormData): Promise<void> {
        try {
            const payload: any = this.preparePutPayload(data);

            const request = new ApiRequest("/source", data.requestId, payload, i18next.t("Source updated."));
            const result = await this.api.put(request);
            
            
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SOURCE_SUBMIT,
                payload: {
                    Id: data.id,
                    message: result.message
                }
            });
        } catch (error) {
            throw error
        }
    }

    async delete(id: string, requestId: string): Promise<void> {
        try {
            const request = new ApiRequest("/Source/" + id, requestId, undefined, i18next.t("Source deleted."));
            const result = await this.api.delete(request);

            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.SOURCE_DELETE,
                payload: {
                    reload: true,
                    message: result.message  
                }
            });

        } catch (error) {
            throw error;
        }
    }

    private preparePostPayload(data: ISourceFormData): any {
        return {
            id: data.id,
            name: data.name,
            description: data.description,
            code: data.code,
            width: data.width,
            stripLength: data.stripLength
        };
    }
    private preparePutPayload(data: ISourceFormData): any {
        return {
            id: data.id,
            name: data.name,
            description: data.description,
            code: data.code,
            width: data.width,
            stripLength: data.stripLength
        };
    }


    private convertResponseData(data: any): ISourceViewData {
        return new SourceViewData( data.id,data.name, data.description, data.code, data.width, data.stripLength);
    }

    private convertResponseListData(data: any) {
        const result: ISourceViewData[] = [];
        if(data.contents){
        data.contents.forEach((element: { id: string; name: string; description: string; code:string; width:number; }) => {
            result.push(this.convertResponseData(element));
        });
    }else{
        data.forEach((element: { id: string; name: string; description: string; code:string; width:number; }) => {
            result.push(this.convertResponseData(element));
        });
    }
    const tempResult = {
        result : data.contents ? result : result,
        currentPage: data.contents ? data.currentPage : 0,
        totalPages: data.contents ?  data.totalPages : 0,
        totalRecords: data.contents ?  data.totalRecords : 0
    }
    return tempResult;
    }
}

const sourceActions = new SourceActions();
export default sourceActions;
